<template>
  <div class="modal-window-small">
    <div>
      <span class="modal-text-small">{{text}}</span>

    <div style="display: flex; justify-content: space-around; align-items: center;">
      <div
        @click="$emit('close')"
        class="shadow_y"
        style="width: 50px !important;  height: 40px; margin: 0 8px; background: #8E8E8E; line-height: 2.2; display: flex; align-items: center; justify-content: center;  border-radius: 4px;"
      >
        <p
          style="color: #2c3e50 !important; margin: 0; font-size: 1.1rem; letter-spacing: 0.4px"
          class="btn-text"
        >
          No
        </p>
      </div>
      <div
        @click="$emit('delete')"
        class="shadow_y"
        style="width: 50px !important; height: 40px; margin: 0; background: #FFBD2E; line-height: 2.2; display: flex; align-items: center; justify-content: center;  border-radius: 4px;"
      >
        <p
          style="color: #2c3e50 !important; margin: 0; font-size: 1.1rem; letter-spacing: 0.4px"
          class="btn-text"
        >
          Yes
        </p>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: [
    "value",
    "isProductDeletionPending",
    "disableActions",
    "text",
    "data"
  ],
  data() {
    return {
      edit: false,
      texty: "",
      exists: false
    };
  },
  computed: {
    ...mapState("user", ["currentUser", "userProfile"])
  },
  methods: {}
};
</script>

<style scoped>
.modal-window-small {
  position: absolute;
  background: none;
  display: flex;
  height: 100%;
  right: 0;
  top: 50%;
  left: 50%;
  background: hsla(120, 100%, 100%, 0.41);
  margin-right: -50%;
  transform: translate(-50%, -50%);
  z-index: 999999;
  transition: all 0.3s;
}

.modal-window-small > div {
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 180px !important;
  position: absolute;
  top: 49%;
  border-radius: 4px;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  padding: 12px 10px;
  background: #FCE8E6;
  color: #D60509;
}

.modal-text-small {
  font-size: 1.1rem !important;
  font-weight: 500 !important;
}

.modal-window-small > div > span {
   font-weight: 100;
}
</style>